import i18n from 'src/i18n';

export const NameTabs = () => [
    { id: 'Tab1', label: i18n.t('admin.adminList.salesStructureAsignment') },
    {
        id: 'Tab2',
        label: i18n.t('accounts.associatedPhysicians.associatedPhysician'),
    },
    { id: 'Tab3', label: i18n.t('admin.nameDetails.associatedAccount') },
];
export const NameTabsBasedOnRole = () => [
    { id: 'Tab1', label: i18n.t('admin.adminList.salesStructureAsignment') },
];
